import styled, {css} from "styled-components";
import {TableProps} from "@FRAMEWORK/ui/types/d";

interface Props extends TableProps {
	types?: "basic" | "vertical";
	lineTop?: boolean;
	line?: boolean;
	background?: boolean;
}

const Table = styled.table<{lineTop?: boolean; types?: "basic" | "vertical"; line?: boolean; background?: boolean}>`
	width: 100%;
	border-top: ${props => (props.lineTop ? "1px solid var(--emp-color);" : "none;")};
	th,
	td {
		position: relative;
		height: 60px;
		border-bottom: 1px solid var(--line-color);
		font-size: var(--default-size);
		font-weight: normal;
		vertical-align: middle;
		word-break: keep-all;

		h1,
		h2,
		h3,
		h4,
		h5 {
			font-size: var(--default-size);
			color: var(--emp-color);
		}
	}

	th {
		background: ${props => (props.background ? "var(--disabled-color)" : "#fff")};
		color: var(--emp-color);
	}

	${props =>
		props.types === "basic"
			? css`
					th,
					td {
						text-align: left;
						&.line-right {
							border-right: 1px solid var(--line-color);
						}
					}
					th {
						padding: 0 20px;
						label {
							position: relative;
						}
					}
					td {
						padding: 10px 20px;
					}
			  `
			: css`
					th,
					td {
						text-align: center;
					}
			  `}

	${props => {
		if (props.line && props.types === "basic") {
			return css`
				td {
					&:not(:last-child) {
						border-right: 1px solid var(--line-color);
					}
				}
			`;
		}
		if (props.line && props.types === "vertical") {
			return css`
				th,
				td {
					&:not(:last-child) {
						border-right: 1px solid var(--line-color);
					}
				}
			`;
		}
	}}
`;

const TableContainer = ({types = "basic", children, lineTop = true, line = true, background = true}: Props) => (
	<Table types={types} lineTop={lineTop} line={line} background={background}>
		{children}
	</Table>
);

export default TableContainer;
